import { motion } from "motion/react";
import React, { PropsWithChildren } from "react";

export const SubtleTopSlideIn = ({ children }: PropsWithChildren) => {
	return (
		<motion.div
			initial={{ opacity: 0, y: -2, height: 0 }}
			animate={{ opacity: 1, y: 0, height: "auto" }}
			exit={{ opacity: 0, y: -2, height: 0 }}
			transition={{ duration: 0.2 }}
			layout
		>
			{children}
		</motion.div>
	);
};
